export default __webpack_public_path__ + "static/media/cliente01_color.aca2ec1f.png";